// look at the URL and parse the paperform
// https://developer.mozilla.org/en-US/docs/Web/API/URL/searchParams

let params = (new URL(document.location)).searchParams;
let getWeight = parseInt(params.get('weight')); 
let getAge = params.get('age'); 
let getActivity = params.get('activity'); 
let removeSpaceActivity = getActivity.replace(/%20/g, ' ');
  
$( document ).ready(function() {
    
  var weight = getWeight;
  var age = getAge;
  var activity = removeSpaceActivity;

    
  if ( age != 'Puppy' ) {
    $('.puppy-message').hide();
    $('.form').show();  
  }
  
  if ( age == 'Puppy' ) {
    $('.puppy-message').show();
    $('.form').hide();
  }
  
  
  /* DON'T EDIT ABOVE THIS SECTION */
  
  // Adult Small Breed, 2-4 lbs, any activity level
  
  if ( age == 'Adult' && weight <= 4) {
    var cupsForMeals = 0.75;
    var largeBagsForMeals = 2;
    var smallBagsForMeals = 4;
    var costforMeals = 1.67;
    var cupsForToppers = 0.25;
    var largeBagsforToppers = 1;
    var smallBagsforToppers = 2;
    var costforToppers = 0.83;
  }
  
  
  
  // Adult Small Breed 5-6 lbs
  
  if ( age == 'Adult' && weight >= 5 && weight <= 6) {
    var cupsForMeals = 1.25;
    var largeBagsForMeals = 3;
    var smallBagsForMeals = 6;
    var costforMeals = 2.50;
    var cupsForToppers = 0.5;
    var largeBagsforToppers = 1;
    var smallBagsforToppers = 3;
    var costforToppers = 0.83;
  }

  
  // Adult Small Breed 7-8 lbs
  
  if ( age == 'Adult' && weight >= 7 && weight <= 8) {
    var cupsForMeals = 1.75;
    var largeBagsForMeals = 3;
    var smallBagsForMeals = 8;
    var costforMeals = 2.50;
    var cupsForToppers = 0.5;
    var largeBagsforToppers = 1;
    var smallBagsforToppers = 3;
    var costforToppers = 0.83;
  }
  
  
  // Adult Small Breed 9-10 lbs
  
  if ( age == 'Adult' && weight >= 9 && weight <= 10) {
    var cupsForMeals = 2;
    var largeBagsForMeals = 4;
    var smallBagsForMeals = 9;
    var costforMeals = 3.33;
    var cupsForToppers = 0.75;
    var largeBagsforToppers = 2;
    var smallBagsforToppers = 4;
    var costforToppers = 1.67;
  }
  
  
  // Adult Small Breed 11-12 lbs
  
  if ( age == 'Adult' && weight >= 11 && weight <= 12) {
    var cupsForMeals = 2.25;
    var largeBagsForMeals = 4;
    var smallBagsForMeals = 11;
    var costforMeals = 3.33;
    var cupsForToppers = 1;
    var largeBagsforToppers = 2;
    var smallBagsforToppers = 5;
    var costforToppers = 1.67;
  }
  
  
  // Adult Small Breed 13-14 lbs
  
  if ( age == 'Adult' && weight >= 13 && weight <= 14) {
    var cupsForMeals = 2.75;
    var largeBagsForMeals = 5;
    var smallBagsForMeals = 13;
    var costforMeals = 4.17;
    var cupsForToppers = 1;
    var largeBagsforToppers = 2;
    var smallBagsforToppers = 5;
    var costforToppers = 1.67;
  }
  
  
  // Adult Small Breed 15-16 lbs
  
  if ( age == 'Adult' && weight >= 15 && weight <= 16) {
    var cupsForMeals = 3;
    var largeBagsForMeals = 6;
    var smallBagsForMeals = 14;
    var costforMeals = 5.00;
    var cupsForToppers = 1;
    var largeBagsforToppers = 2;
    var smallBagsforToppers = 5;
    var costforToppers = 1.67;
  }
  
  // Adult Small Breed 17-18 lbs
  
  if ( age == 'Adult' && weight >= 17 && weight <= 18) {
    var cupsForMeals = 3.25;
    var largeBagsForMeals = 6;
    var smallBagsForMeals = 15;
    var costforMeals = 5.00;
    var cupsForToppers = 1.25;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 6;
    var costforToppers = 2.50;
  }
  
  
  // Adult Small Breed 19-20 lbs
  
  if ( age == 'Adult' && weight >= 19 && weight <= 20) {
    var cupsForMeals = 3.5;
    var largeBagsForMeals = 6;
    var smallBagsForMeals = 16;
    var costforMeals = 5.00;
    var cupsForToppers = 1;
    var largeBagsforToppers = 2;
    var smallBagsforToppers = 5;
    var costforToppers = 1.67;
  }
  
  
  // Adult Small Breed 21-22 lbs
  
  if ( age == 'Adult' && weight >= 21 && weight <= 22) {
    var cupsForMeals = 3.75;
    var largeBagsForMeals = 7;
    var smallBagsForMeals = 17;
    var costforMeals = 5.83;
    var cupsForToppers = 1.5;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 7;
    var costforToppers = 2.50;
  }
  
  
  // Adult Medium Breed 23-24 lbs
  
  if ( age == 'Adult' && weight >= 23 && weight <= 24) {
    var cupsForMeals = 3.5;
    var largeBagsForMeals = 6;
    var smallBagsForMeals = 16;
    var costforMeals = 5.00;
    var cupsForToppers = 1;
    var largeBagsforToppers = 2;
    var smallBagsforToppers = 5;
    var costforToppers = 1.67;
  }
  
  
  // Adult Medium Breed 25-26 lbs
  
  if ( age == 'Adult' && weight >= 25 && weight <= 26) {
    var cupsForMeals = 3.75;
    var largeBagsForMeals = 7;
    var smallBagsForMeals = 17;
    var costforMeals = 5.83;
    var cupsForToppers = 1.5;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 7;
    var costforToppers = 2.50;
  }
  
  
  // Adult Medium Breed 27-28 lbs
  
  if ( age == 'Adult' && weight >= 27 && weight <= 28) {
    var cupsForMeals = 4;
    var largeBagsForMeals = 7;
    var smallBagsForMeals = 18;
    var costforMeals = 5.83;
    var cupsForToppers = 1.5;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 7;
    var costforToppers = 2.50;
  }
  
  
  // Adult Medium Breed 29-30 lbs
  
  if ( age == 'Adult' && weight >= 29 && weight <= 30) {
    var cupsForMeals = 4.25;
    var largeBagsForMeals = 8;
    var smallBagsForMeals = 20;
    var costforMeals = 6.66;
    var cupsForToppers = 1;
    var largeBagsforToppers = 2;
    var smallBagsforToppers = 5;
    var costforToppers = 1.67;
  }
  
  
  // Adult Medium Breed 31-33 lbs
  
  if ( age == 'Adult' && weight >= 31 && weight <= 33) {
    var cupsForMeals = 4.5;
    var largeBagsForMeals = 8;
    var smallBagsForMeals = 21;
    var costforMeals = 6.66;
    var cupsForToppers = 1.5;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 7;
    var costforToppers = 2.50;
  }
  
  
  // Adult Medium Breed 34-35 lbs
  
  if ( age == 'Adult' && weight >= 34 && weight <= 35) {
    var cupsForMeals = 4.5;
    var largeBagsForMeals = 8;
    var smallBagsForMeals = 21;
    var costforMeals = 6.66;
    var cupsForToppers = 1.75;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 8;
    var costforToppers = 2.50;
  }
  
  
  // Adult Medium Breed 36-37 lbs
  
  if ( age == 'Adult' && weight >= 36 && weight <= 37) {
    var cupsForMeals = 4.75;
    var largeBagsForMeals = 9;
    var smallBagsForMeals = 22;
    var costforMeals = 7.50;
    var cupsForToppers = 1.75;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 8;
    var costforToppers = 2.50;
  }
  
  
  // Adult Medium Breed 38-39 lbs
  
  if ( age == 'Adult' && weight >= 38 && weight <= 39) {
    var cupsForMeals = 5;
    var largeBagsForMeals = 9;
    var smallBagsForMeals = 23;
    var costforMeals = 7.50;
    var cupsForToppers = 1.25;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 6;
    var costforToppers = 2.50;
  }
  
  
  // Adult Medium Breed 40-41 lbs
  
  if ( age == 'Adult' && weight >= 40 && weight <= 41) {
    var cupsForMeals = 5.25;
    var largeBagsForMeals = 9;
    var smallBagsForMeals = 24;
    var costforMeals = 7.50;
    var cupsForToppers = 2;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 9;
    var costforToppers = 3.33;
  }
  
  
  // Adult Medium Breed 42-44 lbs
  
  if ( age == 'Adult' && weight >= 42 && weight <= 44) {
    var cupsForMeals = 5.5;
    var largeBagsForMeals = 10;
    var smallBagsForMeals = 25;
    var costforMeals = 8.33;
    var cupsForToppers = 2;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 9;
    var costforToppers = 3.33;
  }
  
  
  // Adult Medium Breed 45-46 lbs
  
  if ( age == 'Adult' && weight >= 45 && weight <= 46) {
    var cupsForMeals = 5.5;
    var largeBagsForMeals = 10;
    var smallBagsForMeals = 25;
    var costforMeals = 8.33;
    var cupsForToppers = 2;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 9;
    var costforToppers = 3.33;
  }
  
  
  // Adult Medium Breed 47-48 lbs
  
  if ( age == 'Adult' && weight >= 47 && weight <= 48) {
    var cupsForMeals = 5.75;
    var largeBagsForMeals = 10;
    var smallBagsForMeals = 26;
    var costforMeals = 8.33;
    var cupsForToppers = 2;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 9;
    var costforToppers = 3.33;
  }
  
  
  // Adult Medium Breed 49-50 lbs
  
  if ( age == 'Adult' && weight >= 49 && weight <= 50) {
    var cupsForMeals = 6;
    var largeBagsForMeals = 11;
    var smallBagsForMeals = 27;
    var costforMeals = 9.16;
    var cupsForToppers = 2.25;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 11;
    var costforToppers = 3.33;
  }
  
  
  // Adult Medium Breed 51-52 lbs
  
  if ( age == 'Adult' && weight >= 51 && weight <= 52) {
    var cupsForMeals = 6.25;
    var largeBagsForMeals = 11;
    var smallBagsForMeals = 28;
    var costforMeals = 9.16;
    var cupsForToppers = 2.25;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 11;
    var costforToppers = 3.33;
  }
  
  
  // Adult Medium Breed 53-55 lbs
  
  if ( age == 'Adult' && weight >= 53 && weight <= 55) {
    var cupsForMeals = 6.5;
    var largeBagsForMeals = 11;
    var smallBagsForMeals = 30;
    var costforMeals = 9.16;
    var cupsForToppers = 1.75;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 8;
    var costforToppers = 2.50;
  }
  
  
  // Adult Large Breed 56-57 lbs
  
  if ( age == 'Adult' && weight >= 56 && weight <= 57) {
    var cupsForMeals = 6.25;
    var largeBagsForMeals = 11;
    var smallBagsForMeals = 28;
    var costforMeals = 9.16;
    var cupsForToppers = 1.5;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 7;
    var costforToppers = 2.50;
  }
  
  
  // Adult Large Breed 58-59 lbs
  
  if ( age == 'Adult' && weight >= 58 && weight <= 59) {
    var cupsForMeals = 6.5;
    var largeBagsForMeals = 11;
    var smallBagsForMeals = 30;
    var costforMeals = 9.16;
    var cupsForToppers = 1.75;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 8;
    var costforToppers = 2.50;
  }
  
  
  // Adult Large Breed 60-61 lbs
  
  if ( age == 'Adult' && weight >= 60 && weight <= 61) {
    var cupsForMeals = 6.75;
    var largeBagsForMeals = 12;
    var smallBagsForMeals = 31;
    var costforMeals = 10.00;
    var cupsForToppers = 2.5;
    var largeBagsforToppers = 5;
    var smallBagsforToppers = 12;
    var costforToppers = 4.17;
  }
  
  
  // Adult Large Breed 62-63 lbs
  
  if ( age == 'Adult' && weight >= 62 && weight <= 63) {
    var cupsForMeals = 6.75;
    var largeBagsForMeals = 12;
    var smallBagsForMeals = 31;
    var costforMeals = 10.00;
    var cupsForToppers = 2.5;
    var largeBagsforToppers = 5;
    var smallBagsforToppers = 12;
    var costforToppers = 4.17;
  }
  
  
  // Adult Large Breed 64-66 lbs
  
  if ( age == 'Adult' && weight >= 64 && weight <= 66) {
    var cupsForMeals = 7;
    var largeBagsForMeals = 12;
    var smallBagsForMeals = 32;
    var costforMeals = 10.00;
    var cupsForToppers = 2.5;
    var largeBagsforToppers = 5;
    var smallBagsforToppers = 12;
    var costforToppers = 4.17;
  }
  
  
  // Adult Large Breed 67-68 lbs
  
  if ( age == 'Adult' && weight >= 64 && weight <= 66) {
    var cupsForMeals = 7.25;
    var largeBagsForMeals = 13;
    var smallBagsForMeals = 33;
    var costforMeals = 10.83;
    var cupsForToppers = 2;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 9;
    var costforToppers = 3.33;
  }
  
  
  // Adult Large Breed 69-70 lbs
  
  if ( age == 'Adult' && weight >= 69 && weight <= 70) {
    var cupsForMeals = 7.25;
    var largeBagsForMeals = 13;
    var smallBagsForMeals = 33;
    var costforMeals = 10.83;
    var cupsForToppers = 2.5;
    var largeBagsforToppers = 5;
    var smallBagsforToppers = 12;
    var costforToppers = 4.17;
  }
  
  
  // Adult Large Breed 71-72 lbs
  
  if ( age == 'Adult' && weight >= 71 && weight <= 72) {
    var cupsForMeals = 7.5;
    var largeBagsForMeals = 13;
    var smallBagsForMeals = 34;
    var costforMeals = 10.83;
    var cupsForToppers = 2.75;
    var largeBagsforToppers = 5;
    var smallBagsforToppers = 13;
    var costforToppers = 4.17;
  }
  
  
  // Adult Large Breed 73-75 lbs
  
  if ( age == 'Adult' && weight >= 73 && weight <= 75) {
    var cupsForMeals = 7.75;
    var largeBagsForMeals = 14;
    var smallBagsForMeals = 35;
    var costforMeals = 11.66;
    var cupsForToppers = 2.75;
    var largeBagsforToppers = 5;
    var smallBagsforToppers = 13;
    var costforToppers = 4.17;
  }
  
  
  // Adult Large Breed 76-77 lbs
  
  if ( age == 'Adult' && weight >= 76 && weight <= 77) {
    var cupsForMeals = 7.75;
    var largeBagsForMeals = 14;
    var smallBagsForMeals = 35;
    var costforMeals = 11.66;
    var cupsForToppers = 2;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 9;
    var costforToppers = 3.33;
  }
  
  
  // Adult Large Breed 78-79 lbs
  
  if ( age == 'Adult' && weight >= 78 && weight <= 79) {
    var cupsForMeals = 8;
    var largeBagsForMeals = 14;
    var smallBagsForMeals = 36;
    var costforMeals = 11.66;
    var cupsForToppers = 3;
    var largeBagsforToppers = 6;
    var smallBagsforToppers = 14;
    var costforToppers = 5.00;
  }
  
  
  // Adult Large Breed 80-81 lbs
  
  if ( age == 'Adult' && weight >= 80 && weight <= 81) {
    var cupsForMeals = 8.25;
    var largeBagsForMeals = 14;
    var smallBagsForMeals = 37;
    var costforMeals = 11.66;
    var cupsForToppers = 3;
    var largeBagsforToppers = 6;
    var smallBagsforToppers = 14;
    var costforToppers = 5.00;
  }
  
  
  // Adult Large Breed 82-86 lbs
  
  if ( age == 'Adult' && weight >= 82 && weight <= 86) {
    var cupsForMeals = 8.5;
    var largeBagsForMeals = 15;
    var smallBagsForMeals = 39;
    var costforMeals = 12.50;
    var cupsForToppers = 2;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 9;
    var costforToppers = 3.33;
  }
  
  
  // Adult Large Breed 87-90 lbs
  
  if ( age == 'Adult' && weight >= 87 && weight <= 90) {
    var cupsForMeals = 8.75;
    var largeBagsForMeals = 15;
    var smallBagsForMeals = 40;
    var costforMeals = 12.50;
    var cupsForToppers = 3.25;
    var largeBagsforToppers = 6;
    var smallBagsforToppers = 15;
    var costforToppers = 5.00;
  }
  
  
  // Adult Large Breed 91-94 lbs
  
  if ( age == 'Adult' && weight >= 91 && weight <= 94) {
    var cupsForMeals = 9;
    var largeBagsForMeals = 16;
    var smallBagsForMeals = 41;
    var costforMeals = 13.33;
    var cupsForToppers = 2.25;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 11;
    var costforToppers = 3.33;
  }
  
  
  // Adult Large Breed 95-99 lbs
  
  if ( age == 'Adult' && weight >= 95 && weight <= 99) {
    var cupsForMeals = 9.5;
    var largeBagsForMeals = 17;
    var smallBagsForMeals = 43;
    var costforMeals = 14.16;
    var cupsForToppers = 3.5;
    var largeBagsforToppers = 6;
    var smallBagsforToppers = 16;
    var costforToppers = 5.00;
  }
  
  
  // Adult Large Breed 100-110 lbs
  
  if ( age == 'Adult' && weight >= 100 && weight <= 110) {
    var cupsForMeals = 10.25;
    var largeBagsForMeals = 18;
    var smallBagsForMeals = 46;
    var costforMeals = 14.99;
    var cupsForToppers = 3.75;
    var largeBagsforToppers = 7;
    var smallBagsforToppers = 17;
    var costforToppers = 5.83;
  }
  
  
  // Adult Large Breed 111-120 lbs
  
  if ( age == 'Adult' && weight >= 111 && weight <= 120) {
    var cupsForMeals = 11;
    var largeBagsForMeals = 19;
    var smallBagsForMeals = 50;
    var costforMeals = 15.83;
    var cupsForToppers = 4;
    var largeBagsforToppers = 7;
    var smallBagsforToppers = 18;
    var costforToppers = 5.83;
  }
  
  
  // Adult Large Breed 121-130 lbs
  
  if ( age == 'Adult' && weight >= 121 && weight <= 130) {
    var cupsForMeals = 11.75;
    var largeBagsForMeals = 20;
    var smallBagsForMeals = 53;
    var costforMeals = 16.66;
    var cupsForToppers = 4.25;
    var largeBagsforToppers = 8;
    var smallBagsforToppers = 20;
    var costforToppers = 6.66;
  }
  
  
  // Adult Large Breed 131-143 lbs
  
  if ( age == 'Adult' && weight >= 131 && weight <= 143) {
    var cupsForMeals = 12.25;
    var largeBagsForMeals = 21;
    var smallBagsForMeals = 55;
    var costforMeals = 17.49;
    var cupsForToppers = 4.5;
    var largeBagsforToppers = 8;
    var smallBagsforToppers = 21;
    var costforToppers = 6.66;
  }
  
  
  // Adult Large Breed 144-154 lbs
  
  if ( age == 'Adult' && weight >= 144 && weight <= 154) {
    var cupsForMeals = 13;
    var largeBagsForMeals = 22;
    var smallBagsForMeals = 59;
    var costforMeals = 18.33;
    var cupsForToppers = 4.75;
    var largeBagsforToppers = 9;
    var smallBagsforToppers = 22;
    var costforToppers = 7.50;
  }
  
  
  // Adult Large Breed 155-165 lbs
  
  if ( age == 'Adult' && weight >= 155 && weight <= 165) {
    var cupsForMeals = 13.75;
    var largeBagsForMeals = 24;
    var smallBagsForMeals = 62;
    var costforMeals = 19.99;
    var cupsForToppers = 5;
    var largeBagsforToppers = 9;
    var smallBagsforToppers = 23;
    var costforToppers = 7.50;
  }
  
  
  // Adult Large Breed 166-176 lbs
  
  if ( age == 'Adult' && weight >= 166 && weight <= 176) {
    var cupsForMeals = 14.5;
    var largeBagsForMeals = 25;
    var smallBagsForMeals = 65;
    var costforMeals = 20.83;
    var cupsForToppers = 5.25;
    var largeBagsforToppers = 9;
    var smallBagsforToppers = 24;
    var costforToppers = 7.50;
  }
  
  
  // Adult Large Breed 177-187 lbs
  
  if ( age == 'Adult' && weight >= 177 && weight <= 187) {
    var cupsForMeals = 15;
    var largeBagsForMeals = 26;
    var smallBagsForMeals = 68;
    var costforMeals = 21.66;
    var cupsForToppers = 5.5;
    var largeBagsforToppers = 10;
    var smallBagsforToppers = 25;
    var costforToppers = 8.33;
  }
  
  
  // Adult Large Breed 188-198 lbs
  
  if ( age == 'Adult' && weight >= 188 && weight <= 198) {
    var cupsForMeals = 15.75;
    var largeBagsForMeals = 27;
    var smallBagsForMeals = 71;
    var costforMeals = 22.49;
    var cupsForToppers = 5.75;
    var largeBagsforToppers = 10;
    var smallBagsforToppers = 26;
    var costforToppers = 8.33;
  }
  
  
  // Adult Large Breed 200-209 lbs
  
  if ( age == 'Adult' && weight >= 200 && weight <= 209) {
    var cupsForMeals = 16.5;
    var largeBagsForMeals = 28;
    var smallBagsForMeals = 74;
    var costforMeals = 23.32;
    var cupsForToppers = 6;
    var largeBagsforToppers = 11;
    var smallBagsforToppers = 27;
    var costforToppers = 9.16;
  }
  
  
  // Adult Large Breed 210-220 lbs
  
  if ( age == 'Adult' && weight >= 210 && weight <= 220) {
    var cupsForMeals = 17;
    var largeBagsForMeals = 29;
    var smallBagsForMeals = 77;
    var costforMeals = 24.16;
    var cupsForToppers = 4.25;
    var largeBagsforToppers = 8;
    var smallBagsforToppers = 20;
    var costforToppers = 6.66;
  }
  
  
  // Senior Small Breed Active 2-4 lbs
  
  if ( age == 'Senior' && weight >= 2 && weight <= 4 && activity == 'Active') {
    var cupsForMeals = 0.75;
    var largeBagsForMeals = 2;
    var smallBagsForMeals = 4;
    var costforMeals = 1.67;
    var cupsForToppers = 0.25;
    var largeBagsforToppers = 1;
    var smallBagsforToppers = 2;
    var costforToppers = 0.83;
  }
  
  
  // Senior Small Breed Active 5-6 lbs
  
  if ( age == 'Senior' && weight >= 5 && weight <= 6 && activity == 'Active') {
    var cupsForMeals = 1;
    var largeBagsForMeals = 2;
    var smallBagsForMeals = 5;
    var costforMeals = 1.67;
    var cupsForToppers = 0.5;
    var largeBagsforToppers = 1;
    var smallBagsforToppers = 3;
    var costforToppers = 0.83;
  }
  
  
  // Senior Small Breed Active 7-8 lbs
  
  if ( age == 'Senior' && weight >= 7 && weight <= 8 && activity == 'Active') {
    var cupsForMeals = 1.5;
    var largeBagsForMeals = 3;
    var smallBagsForMeals = 7;
    var costforMeals = 2.50;
    var cupsForToppers = 0.5;
    var largeBagsforToppers = 1;
    var smallBagsforToppers = 3;
    var costforToppers = 0.83;
  }
  
  
  // Senior Small Breed Active 9-10 lbs
  
  if ( age == 'Senior' && weight >= 9 && weight <= 10 && activity == 'Active') {
    var cupsForMeals = 1.75;
    var largeBagsForMeals = 3;
    var smallBagsForMeals = 8;
    var costforMeals = 2.50;
    var cupsForToppers = 0.75;
    var largeBagsforToppers = 2;
    var smallBagsforToppers = 4;
    var costforToppers = 1.67;
  }
  
  
  // Senior Small Breed Active 11-12 lbs
  
  if ( age == 'Senior' && weight >= 11 && weight <= 12 && activity == 'Active') {
    var cupsForMeals = 2;
    var largeBagsForMeals = 4;
    var smallBagsForMeals = 9;
    var costforMeals = 3.33;
    var cupsForToppers = 0.5;
    var largeBagsforToppers = 1;
    var smallBagsforToppers = 3;
    var costforToppers = 0.83;
  }
  
  
  // Senior Small Breed Active 13-14 lbs
  
  if ( age == 'Senior' && weight >= 13 && weight <= 14 && activity == 'Active') {
    var cupsForMeals = 2.25;
    var largeBagsForMeals = 4;
    var smallBagsForMeals = 11;
    var costforMeals = 3.33;
    var cupsForToppers = 1;
    var largeBagsforToppers = 2;
    var smallBagsforToppers = 5;
    var costforToppers = 1.67;
  }
  
  
  // Senior Small Breed Active 15-16 lbs
  
  if ( age == 'Senior' && weight >= 15 && weight <= 16 && activity == 'Active') {
    var cupsForMeals = 2.75;
    var largeBagsForMeals = 5;
    var smallBagsForMeals = 13;
    var costforMeals = 4.17;
    var cupsForToppers = 1;
    var largeBagsforToppers = 2;
    var smallBagsforToppers = 5;
    var costforToppers = 1.67;
  }
  
  
  // Senior Small Breed Active 17-18 lbs
  
  if ( age == 'Senior' && weight >= 17 && weight <= 18 && activity == 'Active') {
    var cupsForMeals = 3;
    var largeBagsForMeals = 6;
    var smallBagsForMeals = 14;
    var costforMeals = 5.00;
    var cupsForToppers = 0.75;
    var largeBagsforToppers = 2;
    var smallBagsforToppers = 4;
    var costforToppers = 1.67;
  }
  
  
  // Senior Small Breed Active 19-20 lbs
  
  if ( age == 'Senior' && weight >= 19 && weight <= 20 && activity == 'Active') {
    var cupsForMeals = 3.25;
    var largeBagsForMeals = 6;
    var smallBagsForMeals = 15;
    var costforMeals = 5.00;
    var cupsForToppers = 1.25;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 6;
    var costforToppers = 2.50;
  }
  
  
  // Senior Small Breed Active 21-22 lbs
  
  if ( age == 'Senior' && weight >= 21 && weight <= 22 && activity == 'Active') {
    var cupsForMeals = 3.5;
    var largeBagsForMeals = 6;
    var smallBagsForMeals = 16;
    var costforMeals = 5.00;
    var cupsForToppers = 1.25;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 6;
    var costforToppers = 2.50;
  }
  
  
  // Senior Small Breed Less Active 2-4 lbs
  
  if ( age == 'Senior' && weight >= 2 && weight <= 4 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 0.75;
    var largeBagsForMeals = 2;
    var smallBagsForMeals = 4;
    var costforMeals = 1.67;
    var cupsForToppers = 0.25;
    var largeBagsforToppers = 1;
    var smallBagsforToppers = 2;
    var costforToppers = 0.83;
  }
  
  
  // Senior Small Breed Less Active 5-6 lbs
  
  if ( age == 'Senior' && weight >= 5 && weight <= 6 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 1;
    var largeBagsForMeals = 2;
    var smallBagsForMeals = 5;
    var costforMeals = 1.67;
    var cupsForToppers = 0.5;
    var largeBagsforToppers = 1;
    var smallBagsforToppers = 3;
    var costforToppers = 0.83;
  }
  
  
  // Senior Small Breed Less Active 7-8 lbs
  
  if ( age == 'Senior' && weight >= 7 && weight <= 8 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 1.5;
    var largeBagsForMeals = 3;
    var smallBagsForMeals = 7;
    var costforMeals = 2.50;
    var cupsForToppers = 0.375;
    var largeBagsforToppers = 1;
    var smallBagsforToppers = 2;
    var costforToppers = 0.83;
  }
  
  
  // Senior Small Breed Less Active 9-10 lbs
  
  if ( age == 'Senior' && weight >= 9 && weight <= 10 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 1.75;
    var largeBagsForMeals = 3;
    var smallBagsForMeals = 8;
    var costforMeals = 2.50;
    var cupsForToppers = 0.5;
    var largeBagsforToppers = 1;
    var smallBagsforToppers = 3;
    var costforToppers = 0.83;
  }
  
  
  // Senior Small Breed Less Active 11-12 lbs
  
  if ( age == 'Senior' && weight >= 11 && weight <= 12 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 2;
    var largeBagsForMeals = 4;
    var smallBagsForMeals = 9;
    var costforMeals = 3.33;
    var cupsForToppers = 0.75;
    var largeBagsforToppers = 2;
    var smallBagsforToppers = 4;
    var costforToppers = 1.67;
  }
  
  
  // Senior Small Breed Less Active 13-14 lbs
  
  if ( age == 'Senior' && weight >= 13 && weight <= 14 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 2.25;
    var largeBagsForMeals = 4;
    var smallBagsForMeals = 11;
    var costforMeals = 3.33;
    var cupsForToppers = 0.5;
    var largeBagsforToppers = 1;
    var smallBagsforToppers = 3;
    var costforToppers = 0.83;
  }
  
  
  // Senior Small Breed Less Active 15-16 lbs
  
  if ( age == 'Senior' && weight >= 15 && weight <= 16 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 2.5;
    var largeBagsForMeals = 5;
    var smallBagsForMeals = 12;
    var costforMeals = 4.17;
    var cupsForToppers = 1;
    var largeBagsforToppers = 2;
    var smallBagsforToppers = 5;
    var costforToppers = 1.67;
  }
  
  
  // Senior Small Breed Less Active 17-18 lbs
  
  if ( age == 'Senior' && weight >= 17 && weight <= 18 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 2.75;
    var largeBagsForMeals = 5;
    var smallBagsForMeals = 13;
    var costforMeals = 4.17;
    var cupsForToppers = 0.75;
    var largeBagsforToppers = 2;
    var smallBagsforToppers = 4;
    var costforToppers = 1.67;
  }
  
  
  // Senior Small Breed Less Active 19-20 lbs
  
  if ( age == 'Senior' && weight >= 19 && weight <= 20 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 3;
    var largeBagsForMeals = 6;
    var smallBagsForMeals = 14;
    var costforMeals = 5.00;
    var cupsForToppers = 1;
    var largeBagsforToppers = 2;
    var smallBagsforToppers = 5;
    var costforToppers = 1.67;
  }
  
  
  // Senior Small Breed Less Active 21-22 lbs
  
  if ( age == 'Senior' && weight >= 21 && weight <= 22 && activity == 'Overweight or Inactive') {
    alert("test");
    var cupsForMeals = 3.25;
    var largeBagsForMeals = 6;
    var smallBagsForMeals = 15;
    var costforMeals = 5.00;
    var cupsForToppers = 1.25;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 6;
    var costforToppers = 2.50;
  }
  
  
  // Senior Medium Breed 23-24 lbs
  
  if ( age == 'Senior' && weight >= 23 && weight <= 24) {
    var cupsForMeals = 3.25;
    var largeBagsForMeals = 6;
    var smallBagsForMeals = 15;
    var costforMeals = 5.00;
    var cupsForToppers = 1.25;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 6;
    var costforToppers = 2.50;
  }
  
  
  // Senior Medium Breed 25-26 lbs
  
  if ( age == 'Senior' && weight >= 25 && weight <= 26) {
    var cupsForMeals = 3.5;
    var largeBagsForMeals = 6;
    var smallBagsForMeals = 16;
    var costforMeals = 5.00;
    var cupsForToppers = 1.25;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 6;
    var costforToppers = 2.50;
  }
  
  
  // Senior Medium Breed 27-28 lbs
  
  if ( age == 'Senior' && weight >= 27 && weight <= 28) {
    var cupsForMeals = 3.5;
    var largeBagsForMeals = 6;
    var smallBagsForMeals = 16;
    var costforMeals = 5.00;
    var cupsForToppers = 1;
    var largeBagsforToppers = 2;
    var smallBagsforToppers = 5;
    var costforToppers = 1.67;
  }
  
  
  // Senior Medium Breed 29-30 lbs
  
  if ( age == 'Senior' && weight >= 29 && weight <= 30) {
    var cupsForMeals = 3.75;
    var largeBagsForMeals = 7;
    var smallBagsForMeals = 17;
    var costforMeals = 5.83;
    var cupsForToppers = 1.5;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 7;
    var costforToppers = 2.50;
  }
  
  
  // Senior Medium Breed 31-33 lbs
  
  if ( age == 'Senior' && weight >= 31 && weight <= 33) {
    var cupsForMeals = 4;
    var largeBagsForMeals = 7;
    var smallBagsForMeals = 18;
    var costforMeals = 5.83;
    var cupsForToppers = 1.5;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 7;
    var costforToppers = 2.50;
  }
  
  
  // Senior Medium Breed 34-35 lbs
  
  if ( age == 'Senior' && weight >= 34 && weight <= 35) {
    var cupsForMeals = 4.25;
    var largeBagsForMeals = 8;
    var smallBagsForMeals = 20;
    var costforMeals = 6.66;
    var cupsForToppers = 1;
    var largeBagsforToppers = 2;
    var smallBagsforToppers = 5;
    var costforToppers = 1.67;
  }
  
  
  // Senior Medium Breed 36-37 lbs
  
  if ( age == 'Senior' && weight >= 36 && weight <= 37) {
    var cupsForMeals = 4.5;
    var largeBagsForMeals = 8;
    var smallBagsForMeals = 21;
    var costforMeals = 6.66;
    var cupsForToppers = 1.25;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 6;
    var costforToppers = 2.50;
  }
  
  
  // Senior Medium Breed 38-39 lbs
  
  if ( age == 'Senior' && weight >= 38 && weight <= 39) {
    var cupsForMeals = 4.5;
    var largeBagsForMeals = 8;
    var smallBagsForMeals = 21;
    var costforMeals = 6.66;
    var cupsForToppers = 1.75;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 8;
    var costforToppers = 2.50;
  }
  
  
  // Senior Medium Breed 40-41 lbs
  
  if ( age == 'Senior' && weight >= 40 && weight <= 41) {
    var cupsForMeals = 4.75;
    var largeBagsForMeals = 9;
    var smallBagsForMeals = 22;
    var costforMeals = 7.50;
    var cupsForToppers = 1.75;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 8;
    var costforToppers = 2.50;
  }
  
  
  // Senior Medium Breed 42-44 lbs
  
  if ( age == 'Senior' && weight >= 42 && weight <= 44) {
    var cupsForMeals = 5;
    var largeBagsForMeals = 9;
    var smallBagsForMeals = 23;
    var costforMeals = 7.50;
    var cupsForToppers = 1.25;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 6;
    var costforToppers = 2.50;
  }
  
  
  // Senior Medium Breed 45-46 lbs
  
  if ( age == 'Senior' && weight >= 45 && weight <= 46) {
    var cupsForMeals = 5;
    var largeBagsForMeals = 9;
    var smallBagsForMeals = 23;
    var costforMeals = 7.50;
    var cupsForToppers = 2;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 9;
    var costforToppers = 3.33;
  }
  
  
  // Senior Medium Breed 47-48 lbs
  
  if ( age == 'Senior' && weight >= 47 && weight <= 48) {
    var cupsForMeals = 5.25;
    var largeBagsForMeals = 9;
    var smallBagsForMeals = 24;
    var costforMeals = 7.50;
    var cupsForToppers = 2;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 9;
    var costforToppers = 3.33;
  }
  
  
  // Senior Medium Breed 49-50 lbs
  
  if ( age == 'Senior' && weight >= 49 && weight <= 50) {
    var cupsForMeals = 5.5;
    var largeBagsForMeals = 10;
    var smallBagsForMeals = 25;
    var costforMeals = 8.33;
    var cupsForToppers = 2;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 9;
    var costforToppers = 3.33;
  }
  
  
  // Senior Medium Breed 51-52 lbs
  
  if ( age == 'Senior' && weight >= 51 && weight <= 52) {
    var cupsForMeals = 5.75;
    var largeBagsForMeals = 10;
    var smallBagsForMeals = 26;
    var costforMeals = 8.33;
    var cupsForToppers = 1.5;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 7;
    var costforToppers = 2.50;
  }
  
  
  // Senior Medium Breed 53-55 lbs
  
  if ( age == 'Senior' && weight >= 53 && weight <= 55) {
    var cupsForMeals = 5.75;
    var largeBagsForMeals = 10;
    var smallBagsForMeals = 26;
    var costforMeals = 8.33;
    var cupsForToppers = 2;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 9;
    var costforToppers = 3.33;
  }
  
  
  // Senior Large Breed 56-57 lbs
  
  if ( age == 'Senior' && weight >= 56 && weight <= 57) {
    var cupsForMeals = 5.75;
    var largeBagsForMeals = 10;
    var smallBagsForMeals = 26;
    var costforMeals = 8.33;
    var cupsForToppers = 1.5;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 7;
    var costforToppers = 2.50;
  }
  
  
  // Senior Large Breed 58-59 lbs
  
  if ( age == 'Senior' && weight >= 58 && weight <= 59) {
    var cupsForMeals = 5.75;
    var largeBagsForMeals = 10;
    var smallBagsForMeals = 26;
    var costforMeals = 8.33;
    var cupsForToppers = 2;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 9;
    var costforToppers = 3.33;
  }
  
  
  // Senior Large Breed 60-61 lbs
  
  if ( age == 'Senior' && weight >= 60 && weight <= 61) {
    var cupsForMeals = 6;
    var largeBagsForMeals = 11;
    var smallBagsForMeals = 27;
    var costforMeals = 9.16;
    var cupsForToppers = 2.25;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 11;
    var costforToppers = 3.33;
  }
  
  
  // Senior Large Breed 62-63 lbs
  
  if ( age == 'Senior' && weight >= 62 && weight <= 63) {
    var cupsForMeals = 6.25;
    var largeBagsForMeals = 11;
    var smallBagsForMeals = 28;
    var costforMeals = 9.16;
    var cupsForToppers = 2.25;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 11;
    var costforToppers = 3.33;
  }
  
  
  // Senior Large Breed 64-66 lbs
  
  if ( age == 'Senior' && weight >= 64 && weight <= 66) {
    var cupsForMeals = 6.25;
    var largeBagsForMeals = 11;
    var smallBagsForMeals = 28;
    var costforMeals = 9.16;
    var cupsForToppers = 1.5;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 7;
    var costforToppers = 2.50;
  }
  
  
  // Senior Large Breed 67-68 lbs
  
  if ( age == 'Senior' && weight >= 67 && weight <= 68) {
    var cupsForMeals = 6.5;
    var largeBagsForMeals = 11;
    var smallBagsForMeals = 30;
    var costforMeals = 9.16;
    var cupsForToppers = 1.75;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 8;
    var costforToppers = 2.50;
  }
  
  
  // Senior Large Breed 69-70 lbs
  
  if ( age == 'Senior' && weight >= 69 && weight <= 70) {
    var cupsForMeals = 6.75;
    var largeBagsForMeals = 12;
    var smallBagsForMeals = 31;
    var costforMeals = 10.00;
    var cupsForToppers = 2.5;
    var largeBagsforToppers = 5;
    var smallBagsforToppers = 12;
    var costforToppers = 4.17;
  }
  
  
  // Senior Large Breed 71-72 lbs
  
  if ( age == 'Senior' && weight >= 71 && weight <= 72) {
    var cupsForMeals = 6.75;
    var largeBagsForMeals = 12;
    var smallBagsForMeals = 31;
    var costforMeals = 10.00;
    var cupsForToppers = 2.5;
    var largeBagsforToppers = 5;
    var smallBagsforToppers = 12;
    var costforToppers = 4.17;
  }
  
  
  // Senior Large Breed 73-75 lbs
  
  if ( age == 'Senior' && weight >= 73 && weight <= 75) {
    var cupsForMeals = 7;
    var largeBagsForMeals = 12;
    var smallBagsForMeals = 32;
    var costforMeals = 10.00;
    var cupsForToppers = 2.5;
    var largeBagsforToppers = 5;
    var smallBagsforToppers = 12;
    var costforToppers = 4.17;
  }
  
  
  // Senior Large Breed 76-77 lbs
  
  if ( age == 'Senior' && weight >= 76 && weight <= 77) {
    var cupsForMeals = 7;
    var largeBagsForMeals = 12;
    var smallBagsForMeals = 32;
    var costforMeals = 10.00;
    var cupsForToppers = 1.75;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 8;
    var costforToppers = 2.50;
  }
  
  
  // Senior Large Breed 78-79 lbs
  
  if ( age == 'Senior' && weight >= 78 && weight <= 79) {
    var cupsForMeals = 7.25;
    var largeBagsForMeals = 13;
    var smallBagsForMeals = 33;
    var costforMeals = 10.83;
    var cupsForToppers = 2.5;
    var largeBagsforToppers = 5;
    var smallBagsforToppers = 12;
    var costforToppers = 4.17;
  }
  
  
  // Senior Large Breed 80-81 lbs
  
  if ( age == 'Senior' && weight >= 80 && weight <= 81) {
    var cupsForMeals = 7.5;
    var largeBagsForMeals = 13;
    var smallBagsForMeals = 34;
    var costforMeals = 10.83;
    var cupsForToppers = 2.5;
    var largeBagsforToppers = 5;
    var smallBagsforToppers = 12;
    var costforToppers = 4.17;
  }
  
  
  // Senior Large Breed 82-86 lbs
  
  if ( age == 'Senior' && weight >= 82 && weight <= 86) {
    var cupsForMeals = 7.75;
    var largeBagsForMeals = 14;
    var smallBagsForMeals = 35;
    var costforMeals = 11.66;
    var cupsForToppers = 2;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 9;
    var costforToppers = 3.33;
  }
  
  
  // Senior Large Breed 87-90 lbs
  
  if ( age == 'Senior' && weight >= 87 && weight <= 90) {
    var cupsForMeals = 8;
    var largeBagsForMeals = 14;
    var smallBagsForMeals = 36;
    var costforMeals = 11.66;
    var cupsForToppers = 3;
    var largeBagsforToppers = 6;
    var smallBagsforToppers = 14;
    var costforToppers = 5.00;
  }
  
  
  // Senior Large Breed 91-94 lbs
  
  if ( age == 'Senior' && weight >= 91 && weight <= 94) {
    var cupsForMeals = 8.25;
    var largeBagsForMeals = 14;
    var smallBagsForMeals = 37;
    var costforMeals = 11.66;
    var cupsForToppers = 3;
    var largeBagsforToppers = 6;
    var smallBagsforToppers = 14;
    var costforToppers = 5.00;
  }
  
  
  // Senior Large Breed 95-99 lbs
  
  if ( age == 'Senior' && weight >= 95 && weight <= 99) {
    var cupsForMeals = 8.5;
    var largeBagsForMeals = 15;
    var smallBagsForMeals = 39;
    var costforMeals = 12.50;
    var cupsForToppers = 2.25;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 11;
    var costforToppers = 3.33;
  }
  
  
  // Senior Large Breed 100-110 lbs
  
  if ( age == 'Senior' && weight >= 100 && weight <= 110) {
    var cupsForMeals = 9.25;
    var largeBagsForMeals = 16;
    var smallBagsForMeals = 42;
    var costforMeals = 13.33;
    var cupsForToppers = 2.5;
    var largeBagsforToppers = 5;
    var smallBagsforToppers = 12;
    var costforToppers = 4.17;
  }
  
  
  // Senior Large Breed 111-120 lbs
  
  if ( age == 'Senior' && weight >= 111 && weight <= 120) {
    var cupsForMeals = 10;
    var largeBagsForMeals = 17;
    var smallBagsForMeals = 45;
    var costforMeals = 14.16;
    var cupsForToppers = 2.5;
    var largeBagsforToppers = 5;
    var smallBagsforToppers = 12;
    var costforToppers = 4.17;
  }
  
  
  // Senior Large Breed 121-130 lbs
  
  if ( age == 'Senior' && weight >= 121 && weight <= 130) {
    var cupsForMeals = 10.5;
    var largeBagsForMeals = 18;
    var smallBagsForMeals = 48;
    var costforMeals = 14.99;
    var cupsForToppers = 2.75;
    var largeBagsforToppers = 5;
    var smallBagsforToppers = 13;
    var costforToppers = 4.17;
  }
  
  
  // Senior Large Breed 131-143 lbs
  
  if ( age == 'Senior' && weight >= 131 && weight <= 143) {
    var cupsForMeals = 11.25;
    var largeBagsForMeals = 19;
    var smallBagsForMeals = 51;
    var costforMeals = 15.83;
    var cupsForToppers = 3;
    var largeBagsforToppers = 6;
    var smallBagsforToppers = 14;
    var costforToppers = 5.00;
  }
  
  
  // Senior Large Breed 144-154 lbs
  
  if ( age == 'Senior' && weight >= 144 && weight <= 154) {
    var cupsForMeals = 11.75;
    var largeBagsForMeals = 20;
    var smallBagsForMeals = 53;
    var costforMeals = 16.66;
    var cupsForToppers = 3;
    var largeBagsforToppers = 6;
    var smallBagsforToppers = 14;
    var costforToppers = 5.00;
  }
  
  
  // Senior Large Breed 155-165 lbs
  
  if ( age == 'Senior' && weight >= 155 && weight <= 165) {
    var cupsForMeals = 12.5;
    var largeBagsForMeals = 22;
    var smallBagsForMeals = 56;
    var costforMeals = 18.33;
    var cupsForToppers = 4.5;
    var largeBagsforToppers = 8;
    var smallBagsforToppers = 21;
    var costforToppers = 6.66;
  }
  
  
  // Senior Large Breed 166-176 lbs
  
  if ( age == 'Senior' && weight >= 73 && weight <= 75) {
    var cupsForMeals = 13;
    var largeBagsForMeals = 22;
    var smallBagsForMeals = 59;
    var costforMeals = 18.33;
    var cupsForToppers = 4.75;
    var largeBagsforToppers = 9;
    var smallBagsforToppers = 22;
    var costforToppers = 7.50;
  }
  
  
  // Senior Large Breed 177-187 lbs
  
  if ( age == 'Senior' && weight >= 177 && weight <= 187) {
    var cupsForMeals = 13.75;
    var largeBagsForMeals = 24;
    var smallBagsForMeals = 62;
    var costforMeals = 19.99;
    var cupsForToppers = 5;
    var largeBagsforToppers = 9;
    var smallBagsforToppers = 23;
    var costforToppers = 7.50;
  }
  
  
  // Senior Large Breed 188-198 lbs
  
  if ( age == 'Senior' && weight >= 188 && weight <= 198) {
    var cupsForMeals = 14.25;
    var largeBagsForMeals = 25;
    var smallBagsForMeals = 64;
    var costforMeals = 20.83;
    var cupsForToppers = 5;
    var largeBagsforToppers = 9;
    var smallBagsforToppers = 23;
    var costforToppers = 7.50;
  }
  
  
  // Senior Large Breed 200-209 lbs
  
  if ( age == 'Senior' && weight >= 200 && weight <= 209) {
    var cupsForMeals = 14.75;
    var largeBagsForMeals = 25;
    var smallBagsForMeals = 67;
    var costforMeals = 20.83;
    var cupsForToppers = 3.75;
    var largeBagsforToppers = 7;
    var smallBagsforToppers = 17;
    var costforToppers = 5.83;
  }
  
  
  // Senior Large Breed 210-220 lbs
  
  if ( age == 'Senior' && weight >= 210 && weight <= 220) {
    var cupsForMeals = 15.5;
    var largeBagsForMeals = 27;
    var smallBagsForMeals = 70;
    var costforMeals = 22.49;
    var cupsForToppers = 4;
    var largeBagsforToppers = 7;
    var smallBagsforToppers = 18;
    var costforToppers = 5.83;
  }
  
  
  // Adult Highly Active Medium Breed 23-24 lbs
  
  if ( age == 'Adult' && weight >= 23 && weight <= 24 && activity == 'Highly Active') {
    var cupsForMeals = 4;
    var largeBagsForMeals = 7;
    var smallBagsForMeals = 18;
    var costforMeals = 5.83;
    var cupsForToppers = 1.5;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 7;
    var costforToppers = 2.50;
  }
  
  
  // Adult Highly Active Medium Breed 25-26 lbs
  
  if ( age == 'Adult' && weight >= 25 && weight <= 26 && activity == 'Highly Active') {
    var cupsForMeals = 4.5;
    var largeBagsForMeals = 8;
    var smallBagsForMeals = 21;
    var costforMeals = 6.66;
    var cupsForToppers = 1.5;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 7;
    var costforToppers = 2.50;
  }
  
  
  // Adult Highly Active Medium Breed 27-28 lbs
  
  if ( age == 'Adult' && weight >= 27 && weight <= 28 && activity == 'Highly Active') {
    var cupsForMeals = 4.75;
    var largeBagsForMeals = 9;
    var smallBagsForMeals = 22;
    var costforMeals = 7.50;
    var cupsForToppers = 1.75;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 8;
    var costforToppers = 2.50;
  }
  
  
  // Adult Highly Active Medium Breed 29-30 lbs
  
  if ( age == 'Adult' && weight >= 29 && weight <= 30 && activity == 'Highly Active') {
    var cupsForMeals = 5;
    var largeBagsForMeals = 9;
    var smallBagsForMeals = 23;
    var costforMeals = 7.50;
    var cupsForToppers = 1.25;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 6;
    var costforToppers = 2.50;
  }
  
  
  // Adult Highly Active Medium Breed 31-33 lbs
  
  if ( age == 'Adult' && weight >= 31 && weight <= 33 && activity == 'Highly Active') {
    var cupsForMeals = 5.25;
    var largeBagsForMeals = 9;
    var smallBagsForMeals = 24;
    var costforMeals = 7.50;
    var cupsForToppers = 2;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 9;
    var costforToppers = 3.33;
  }
  
  
  // Adult Highly Active Medium Breed 34-35 lbs
  
  if ( age == 'Adult' && weight >= 34 && weight <= 35 && activity == 'Highly Active') {
    var cupsForMeals = 5.5;
    var largeBagsForMeals = 10;
    var smallBagsForMeals = 25;
    var costforMeals = 8.33;
    var cupsForToppers = 2;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 9;
    var costforToppers = 3.33;
  }
  
  
  // Adult Highly Active Medium Breed 36-37 lbs
  
  if ( age == 'Adult' && weight >= 36 && weight <= 37 && activity == 'Highly Active') {
    var cupsForMeals = 5.75;
    var largeBagsForMeals = 10;
    var smallBagsForMeals = 26;
    var costforMeals = 8.33;
    var cupsForToppers = 1.5;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 7;
    var costforToppers = 2.50;
  }
  
  
  // Adult Highly Active Medium Breed 38-39 lbs
  
  if ( age == 'Adult' && weight >= 38 && weight <= 39 && activity == 'Highly Active') {
    var cupsForMeals = 6;
    var largeBagsForMeals = 11;
    var smallBagsForMeals = 27;
    var costforMeals = 9.16;
    var cupsForToppers = 2;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 9;
    var costforToppers = 3.33;
  }
  
  
  // Adult Highly Active Medium Breed 40-41 lbs
  
  if ( age == 'Adult' && weight >= 40 && weight <= 41 && activity == 'Highly Active') {
    var cupsForMeals = 6.25;
    var largeBagsForMeals = 11;
    var smallBagsForMeals = 28;
    var costforMeals = 9.16;
    var cupsForToppers = 2.25;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 11;
    var costforToppers = 3.33;
  }
  
  
  // Adult Highly Active Medium Breed 42-44 lbs
  
  if ( age == 'Adult' && weight >= 42 && weight <= 44 && activity == 'Highly Active') {
    var cupsForMeals = 6.5;
    var largeBagsForMeals = 11;
    var smallBagsForMeals = 30;
    var costforMeals = 9.16;
    var cupsForToppers = 1.75;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 8;
    var costforToppers = 2.50;
  }
  
  
  // Adult Highly Active Medium Breed 45-46 lbs
  
  if ( age == 'Adult' && weight >= 45 && weight <= 46 && activity == 'Highly Active') {
    var cupsForMeals = 6.5;
    var largeBagsForMeals = 11;
    var smallBagsForMeals = 30;
    var costforMeals = 9.16;
    var cupsForToppers = 2.5;
    var largeBagsforToppers = 5;
    var smallBagsforToppers = 12;
    var costforToppers = 4.17;
  }
  
  
  // Adult Highly Active Medium Breed 47-48 lbs
  
  if ( age == 'Adult' && weight >= 47 && weight <= 48 && activity == 'Highly Active') {
    var cupsForMeals = 6.75;
    var largeBagsForMeals = 12;
    var smallBagsForMeals = 31;
    var costforMeals = 10.00;
    var cupsForToppers = 2.5;
    var largeBagsforToppers = 5;
    var smallBagsforToppers = 12;
    var costforToppers = 4.17;
  }
  
  
  // Adult Highly Active Medium Breed 49-50 lbs
  
  if ( age == 'Adult' && weight >= 49 && weight <= 50 && activity == 'Highly Active') {
    var cupsForMeals = 7;
    var largeBagsForMeals = 12;
    var smallBagsForMeals = 32;
    var costforMeals = 10.00;
    var cupsForToppers = 1.75;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 8;
    var costforToppers = 2.50;
  }
  
  
  // Adult Highly Active Medium Breed 51-52 lbs
  
  if ( age == 'Adult' && weight >= 51 && weight <= 52 && activity == 'Highly Active') {
    var cupsForMeals = 7.25;
    var largeBagsForMeals = 13;
    var smallBagsForMeals = 33;
    var costforMeals = 10.83;
    var cupsForToppers = 2.5;
    var largeBagsforToppers = 5;
    var smallBagsforToppers = 12;
    var costforToppers = 4.17;
  }
  
  
  // Adult Highly Active Medium Breed 53-55 lbs
  
  if ( age == 'Adult' && weight >= 53 && weight <= 55 && activity == 'Highly Active') {
    var cupsForMeals = 7.5;
    var largeBagsForMeals = 13;
    var smallBagsForMeals = 34;
    var costforMeals = 10.83;
    var cupsForToppers = 2.75;
    var largeBagsforToppers = 5;
    var smallBagsforToppers = 13;
    var costforToppers = 4.17;
  }
  
  
  // Adult Highly Active Large Breed 56-57 lbs
  
  if ( age == 'Adult' && weight >= 56 && weight <= 57 && activity == 'Highly Active') {
    var cupsForMeals = 7.75;
    var largeBagsForMeals = 14;
    var smallBagsForMeals = 35;
    var costforMeals = 11.66;
    var cupsForToppers = 2;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 9;
    var costforToppers = 3.33;
  }
  
  
  // Adult Highly Active Large Breed 58-59 lbs
  
  if ( age == 'Adult' && weight >= 58 && weight <= 59 && activity == 'Highly Active') {
    var cupsForMeals = 8;
    var largeBagsForMeals = 14;
    var smallBagsForMeals = 36;
    var costforMeals = 11.66;
    var cupsForToppers = 3;
    var largeBagsforToppers = 6;
    var smallBagsforToppers = 14;
    var costforToppers = 5.00;
  }
  
  
  // Adult Highly Active Large Breed 60-61 lbs
  
  if ( age == 'Adult' && weight >= 60 && weight <= 61 && activity == 'Highly Active') {
    var cupsForMeals = 8.25;
    var largeBagsForMeals = 14;
    var smallBagsForMeals = 37;
    var costforMeals = 11.66;
    var cupsForToppers = 3;
    var largeBagsforToppers = 6;
    var smallBagsforToppers = 14;
    var costforToppers = 5.00;
  }
  
  
  // Adult Highly Active Large Breed 62-63 lbs
  
  if ( age == 'Adult' && weight >= 62 && weight <= 63 && activity == 'Highly Active') {
    var cupsForMeals = 8.5;
    var largeBagsForMeals = 15;
    var smallBagsForMeals = 39;
    var costforMeals = 12.50;
    var cupsForToppers = 2.25;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 11;
    var costforToppers = 3.33;
  }
  
  
  // Adult Highly Active Large Breed 64-66 lbs
  
  if ( age == 'Adult' && weight >= 64 && weight <= 66 && activity == 'Highly Active') {
    var cupsForMeals = 8.5;
    var largeBagsForMeals = 15;
    var smallBagsForMeals = 39;
    var costforMeals = 12.50;
    var cupsForToppers = 3;
    var largeBagsforToppers = 6;
    var smallBagsforToppers = 14;
    var costforToppers = 5.00;
  }
  
  
  // Adult Highly Active Large Breed 67-68 lbs
  
  if ( age == 'Adult' && weight >= 67 && weight <= 68 && activity == 'Highly Active') {
    var cupsForMeals = 8.75;
    var largeBagsForMeals = 15;
    var smallBagsForMeals = 40;
    var costforMeals = 12.50;
    var cupsForToppers = 3.25;
    var largeBagsforToppers = 6;
    var smallBagsforToppers = 15;
    var costforToppers = 5.00;
  }
  
  
  // Adult Highly Active Large Breed 69-70 lbs
  
  if ( age == 'Adult' && weight >= 69 && weight <= 70 && activity == 'Highly Active') {
    var cupsForMeals = 9;
    var largeBagsForMeals = 16;
    var smallBagsForMeals = 41;
    var costforMeals = 13.33;
    var cupsForToppers = 3.25;
    var largeBagsforToppers = 6;
    var smallBagsforToppers = 15;
    var costforToppers = 5.00;
  }
  
  
  // Adult Highly Active Large Breed 71-72 lbs
  
  if ( age == 'Adult' && weight >= 71 && weight <= 72 && activity == 'Highly Active') {
    var cupsForMeals = 9.25;
    var largeBagsForMeals = 16;
    var smallBagsForMeals = 42;
    var costforMeals = 13.33;
    var cupsForToppers = 2.5;
    var largeBagsforToppers = 5;
    var smallBagsforToppers = 12;
    var costforToppers = 4.17;
  }
  
  
  // Adult Highly Active Large Breed 73-75 lbs
  
  if ( age == 'Adult' && weight >= 73 && weight <= 75 && activity == 'Highly Active') {
    var cupsForMeals = 9.5;
    var largeBagsForMeals = 17;
    var smallBagsForMeals = 43;
    var costforMeals = 14.16;
    var cupsForToppers = 3.5;
    var largeBagsforToppers = 6;
    var smallBagsforToppers = 16;
    var costforToppers = 5.00;
  }
  
  
  // Adult Highly Active Large Breed 76-77 lbs
  
  if ( age == 'Adult' && weight >= 76 && weight <= 77 && activity == 'Highly Active') {
    var cupsForMeals = 9.75;
    var largeBagsForMeals = 17;
    var smallBagsForMeals = 44;
    var costforMeals = 14.16;
    var cupsForToppers = 3.5;
    var largeBagsforToppers = 6;
    var smallBagsforToppers = 16;
    var costforToppers = 5.00;
  }
  
  
  // Adult Highly Active Large Breed 78-79 lbs
  
  if ( age == 'Adult' && weight >= 78 && weight <= 79 && activity == 'Highly Active') {
    var cupsForMeals = 9.75;
    var largeBagsForMeals = 17;
    var smallBagsForMeals = 44;
    var costforMeals = 14.16;
    var cupsForToppers = 2.5;
    var largeBagsforToppers = 5;
    var smallBagsforToppers = 12;
    var costforToppers = 4.17;
  }
  
  
  // Adult Highly Active Large Breed 80-81 lbs
  
  if ( age == 'Adult' && weight >= 80 && weight <= 81 && activity == 'Highly Active') {
    var cupsForMeals = 10;
    var largeBagsForMeals = 17;
    var smallBagsForMeals = 45;
    var costforMeals = 14.16;
    var cupsForToppers = 3.5;
    var largeBagsforToppers = 6;
    var smallBagsforToppers = 16;
    var costforToppers = 5.00;
  }
  
  
  // Adult Highly Active Large Breed 82-86 lbs
  
  if ( age == 'Adult' && weight >= 82 && weight <= 86 && activity == 'Highly Active') {
    var cupsForMeals = 10.5;
    var largeBagsForMeals = 18;
    var smallBagsForMeals = 48;
    var costforMeals = 14.99;
    var cupsForToppers = 3.75;
    var largeBagsforToppers = 7;
    var smallBagsforToppers = 17;
    var costforToppers = 5.83;
  }
  
  
  // Adult Highly Active Large Breed 87-90 lbs
  
  if ( age == 'Adult' && weight >= 86 && weight <= 90 && activity == 'Highly Active') {
    var cupsForMeals = 10.75;
    var largeBagsForMeals = 19;
    var smallBagsForMeals = 49;
    var costforMeals = 15.83;
    var cupsForToppers = 4;
    var largeBagsforToppers = 7;
    var smallBagsforToppers = 18;
    var costforToppers = 5.83;
  }
  
  
  // Adult Highly Active Large Breed 91-94 lbs
  
  if ( age == 'Adult' && weight >= 91 && weight <= 94 && activity == 'Highly Active') {
    var cupsForMeals = 11.25;
    var largeBagsForMeals = 19;
    var smallBagsForMeals = 51;
    var costforMeals = 15.83;
    var cupsForToppers = 3;
    var largeBagsforToppers = 6;
    var smallBagsforToppers = 14;
    var costforToppers = 5.00;
  }
  
  
  // Adult Highly Active Large Breed 95-99 lbs
  
  if ( age == 'Adult' && weight >= 95 && weight <= 99 && activity == 'Highly Active') {
    var cupsForMeals = 11.5;
    var largeBagsForMeals = 20;
    var smallBagsForMeals = 52;
    var costforMeals = 16.66;
    var cupsForToppers = 4.25;
    var largeBagsforToppers = 8;
    var smallBagsforToppers = 20;
    var costforToppers = 6.66;
  }
  
  // Adult Overweight Inactive 23-24 lbs
  
  if ( age == 'Adult' && weight >= 23 && weight <= 24 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 3.25;
    var largeBagsForMeals = 6;
    var smallBagsForMeals = 15;
    var costforMeals = 5.00;
    var cupsForToppers = 1.25;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 6;
    var costforToppers = 2.50;
  }
  
  
  // Adult Overweight Inactive 25-26 lbs
  
  if ( age == 'Adult' && weight >= 25 && weight <= 26 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 3.5;
    var largeBagsForMeals = 6;
    var smallBagsForMeals = 16;
    var costforMeals = 5.00;
    var cupsForToppers = 1.25;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 6;
    var costforToppers = 2.50;
  }
  
  
  // Adult Overweight Inactive 27-28 lbs
  
  if ( age == 'Adult' && weight >= 27 && weight <= 28 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 3.5;
    var largeBagsForMeals = 6;
    var smallBagsForMeals = 16;
    var costforMeals = 5.00;
    var cupsForToppers = 0.875;
    var largeBagsforToppers = 2;
    var smallBagsforToppers = 4;
    var costforToppers = 1.67;
  }
  
  
  // Adult Overweight Inactive 29-30 lbs
  
  if ( age == 'Adult' && weight >= 29 && weight <= 30 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 3.75;
    var largeBagsForMeals = 7;
    var smallBagsForMeals = 17;
    var costforMeals = 5.83;
    var cupsForToppers = 1.5;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 7;
    var costforToppers = 2.50;
  }
  
  
  // Adult Overweight Inactive 31-33 lbs
  
  if ( age == 'Adult' && weight >= 31 && weight <= 33 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 4;
    var largeBagsForMeals = 7;
    var smallBagsForMeals = 18;
    var costforMeals = 5.83;
    var cupsForToppers = 1.5;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 7;
    var costforToppers = 2.50;
  }
  
  
  // Adult Overweight Inactive 34-35 lbs
  
  if ( age == 'Adult' && weight >= 34 && weight <= 35 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 4.25;
    var largeBagsForMeals = 8;
    var smallBagsForMeals = 20;
    var costforMeals = 6.66;
    var cupsForToppers = 1;
    var largeBagsforToppers = 2;
    var smallBagsforToppers = 5;
    var costforToppers = 1.67;
  } 
  
  // Adult Overweight Inactive 36-37 lbs
  
  if ( age == 'Adult' && weight >= 36 && weight <= 37 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 4.5;
    var largeBagsForMeals = 8;
    var smallBagsForMeals = 21;
    var costforMeals = 6.66;
    var cupsForToppers = 1.25;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 6;
    var costforToppers = 2.50;
  }
  
  
  // Adult Overweight Inactive 38-39 lbs
  
  if ( age == 'Adult' && weight >= 38 && weight <= 39 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 4.5;
    var largeBagsForMeals = 8;
    var smallBagsForMeals = 21;
    var costforMeals = 6.66;
    var cupsForToppers = 1.75;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 8;
    var costforToppers = 2.50;
  }
  
  
  // Adult Overweight Inactive 40-41 lbs
  
  if ( age == 'Adult' && weight >= 40 && weight <= 41 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 4.75;
    var largeBagsForMeals = 9;
    var smallBagsForMeals = 22;
    var costforMeals = 7.50;
    var cupsForToppers = 1.75;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 8;
    var costforToppers = 2.50;
  }
  
  
  // Adult Overweight Inactive 42-44 lbs
  
  if ( age == 'Adult' && weight >= 42 && weight <= 44 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 5;
    var largeBagsForMeals = 9;
    var smallBagsForMeals = 23;
    var costforMeals = 7.50;
    var cupsForToppers = 1.25;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 6;
    var costforToppers = 2.50;
  }
  
  
  // Adult Overweight Inactive 45-46 lbs
  
  if ( age == 'Adult' && weight >= 45 && weight <= 46 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 5;
    var largeBagsForMeals = 9;
    var smallBagsForMeals = 23;
    var costforMeals = 7.50;
    var cupsForToppers = 2;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 9;
    var costforToppers = 3.33;
  }
  
  
  // Adult Overweight Inactive 47-48 lbs
  
  if ( age == 'Adult' && weight >= 47 && weight <= 48 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 5.25;
    var largeBagsForMeals = 9;
    var smallBagsForMeals = 24;
    var costforMeals = 7.50;
    var cupsForToppers = 2;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 9;
    var costforToppers = 3.33;
  }
  
  
  // Adult Overweight Inactive 49-50 lbs
  
  if ( age == 'Adult' && weight >= 49 && weight <= 50 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 5.5;
    var largeBagsForMeals = 10;
    var smallBagsForMeals = 25 ;
    var costforMeals = 8.33;
    var cupsForToppers = 2;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 9;
    var costforToppers = 3.33;
  }
  
  
  // Adult Overweight Inactive 51-52 lbs
  
  if ( age == 'Adult' && weight >= 51 && weight <= 52 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 5.75;
    var largeBagsForMeals = 10;
    var smallBagsForMeals = 26;
    var costforMeals = 8.33;
    var cupsForToppers = 2;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 9;
    var costforToppers = 3.33;
  }
  
  
  // Adult Overweight Inactive 53-55 lbs
  
  if ( age == 'Adult' && weight >= 53 && weight <= 55 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 5.75;
    var largeBagsForMeals = 10;
    var smallBagsForMeals = 26;
    var costforMeals = 8.33;
    var cupsForToppers = 2;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 9;
    var costforToppers = 3.33;
  }
  
  
  // Adult Overweight Inactive 56-57 lbs
  
  if ( age == 'Adult' && weight >= 56 && weight <= 57 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 6;
    var largeBagsForMeals = 11;
    var smallBagsForMeals = 27;
    var costforMeals = 9.16;
    var cupsForToppers = 2.25;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 11;
    var costforToppers = 3.33;
  }
  
  
  // Adult Overweight Inactive 58-59 lbs
  
  if ( age == 'Adult' && weight >= 58 && weight <= 59 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 6.25;
    var largeBagsForMeals = 11;
    var smallBagsForMeals = 28;
    var costforMeals = 9.16;
    var cupsForToppers = 2.25;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 11;
    var costforToppers = 3.33;
  }
  
  
  // Adult Overweight Inactive 60-61 lbs
  
  if ( age == 'Adult' && weight >= 60 && weight <= 61 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 6.25;
    var largeBagsForMeals = 11;
    var smallBagsForMeals = 28;
    var costforMeals = 9.16;
    var cupsForToppers = 1.5;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 7;
    var costforToppers = 2.50;
  }
  
  
  // Adult Overweight Inactive 62-63 lbs
  
  if ( age == 'Adult' && weight >= 62 && weight <= 63 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 6.5;
    var largeBagsForMeals = 11;
    var smallBagsForMeals = 30;
    var costforMeals = 9.16;
    var cupsForToppers = 2.5;
    var largeBagsforToppers = 5;
    var smallBagsforToppers = 12;
    var costforToppers = 4.17;
  }
  
  
  // Adult Overweight Inactive 64-66 lbs
  
  if ( age == 'Adult' && weight >= 64 && weight <= 66 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 6.75;
    var largeBagsForMeals = 12;
    var smallBagsForMeals = 31;
    var costforMeals = 10.00;
    var cupsForToppers = 2.5;
    var largeBagsforToppers = 5;
    var smallBagsforToppers = 12;
    var costforToppers = 4.17;
  }
  
  
  // Adult Overweight Inactive 67-68 lbs
  
  if ( age == 'Adult' && weight >= 67 && weight <= 68 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 6.75;
    var largeBagsForMeals = 12;
    var smallBagsForMeals = 31;
    var costforMeals = 10.00;
    var cupsForToppers = 2.5;
    var largeBagsforToppers = 5;
    var smallBagsforToppers = 12;
    var costforToppers = 4.17;
  }
  
  
  // Adult Overweight Inactive 69-70 lbs
  
  if ( age == 'Adult' && weight >= 69 && weight <= 70 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 7;
    var largeBagsForMeals = 12;
    var smallBagsForMeals = 32;
    var costforMeals = 10.00;
    var cupsForToppers = 1.75;
    var largeBagsforToppers = 3;
    var smallBagsforToppers = 8;
    var costforToppers = 2.50;
  }
  
  
  // Adult Overweight Inactive 71-72 lbs
  
  if ( age == 'Adult' && weight >= 71 && weight <= 72 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 7.25;
    var largeBagsForMeals = 13;
    var smallBagsForMeals = 33;
    var costforMeals = 10.83;
    var cupsForToppers = 2;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 9;
    var costforToppers = 3.33;
  }
  
  
  // Adult Overweight Inactive 73-75 lbs
  
  if ( age == 'Adult' && weight >= 73 && weight <= 75 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 7.25;
    var largeBagsForMeals = 13;
    var smallBagsForMeals = 33;
    var costforMeals = 10.83;
    var cupsForToppers = 2.5;
    var largeBagsforToppers = 5;
    var smallBagsforToppers = 12;
    var costforToppers = 4.17;
  }
  
  
  // Adult Overweight Inactive 76-77 lbs
  
  if ( age == 'Adult' && weight >= 76 && weight <= 76 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 7.5;
    var largeBagsForMeals = 13;
    var smallBagsForMeals = 34;
    var costforMeals = 10.83;
    var cupsForToppers = 2.75;
    var largeBagsforToppers = 5;
    var smallBagsforToppers = 13;
    var costforToppers = 4.17;
  }
  
  
  // Adult Overweight Inactive 78-79 lbs
  
  if ( age == 'Adult' && weight >= 78 && weight <= 79 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 7.5;
    var largeBagsForMeals = 13;
    var smallBagsForMeals = 34;
    var costforMeals = 10.83;
    var cupsForToppers = 2.75;
    var largeBagsforToppers = 5;
    var smallBagsforToppers = 13;
    var costforToppers = 4.17;
  }
  
  
  // Adult Overweight Inactive 80-81 lbs
  
  if ( age == 'Adult' && weight >= 80 && weight <= 81 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 7.75;
    var largeBagsForMeals = 14;
    var smallBagsForMeals = 35;
    var costforMeals = 11.66;
    var cupsForToppers = 2;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 9;
    var costforToppers = 3.33;
  }
  
  
  // Adult Overweight Inactive 82-86 lbs
  
  if ( age == 'Adult' && weight >= 82 && weight <= 86 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 8;
    var largeBagsForMeals = 14;
    var smallBagsForMeals = 36;
    var costforMeals = 11.66;
    var cupsForToppers = 3;
    var largeBagsforToppers = 6;
    var smallBagsforToppers = 14;
    var costforToppers = 5.00;
  }
  
  
  // Adult Overweight Inactive 87-90 lbs
  
  if ( age == 'Adult' && weight >= 87 && weight <= 90 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 8.25;
    var largeBagsForMeals = 14;
    var smallBagsForMeals = 37;
    var costforMeals = 11.66;
    var cupsForToppers = 2;
    var largeBagsforToppers = 4;
    var smallBagsforToppers = 9;
    var costforToppers = 3.33;
  }
  
  
  // Adult Overweight Inactive 91-94 lbs
  
  if ( age == 'Adult' && weight >= 91 && weight <= 94 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 8.75;
    var largeBagsForMeals = 15;
    var smallBagsForMeals = 40;
    var costforMeals = 12.50;
    var cupsForToppers = 3;
    var largeBagsforToppers = 6;
    var smallBagsforToppers = 14;
    var costforToppers = 5.00;
  }
  
  
  // Adult Overweight Inactive 95-99 lbs
  
  if ( age == 'Adult' && weight >= 95 && weight <= 99 && activity == 'Overweight or Inactive') {
    var cupsForMeals = 9;
    var largeBagsForMeals = 16;
    var smallBagsForMeals = 41;
    var costforMeals = 13.33;
    var cupsForToppers = 3.25;
    var largeBagsforToppers = 6;
    var smallBagsforToppers = 15;
    var costforToppers = 5.00;
  }
  
 
 
  
  $('.cupsForMeals').text(cupsForMeals);
  $('.largeBagsForMeals').text(largeBagsForMeals);
  //$('.smallBagsForMeals').text(smallBagsForMeals);
  $('.costforMeals').text(formatter.format(costforMeals * 1.2 / 2));
  $('.cupsForToppers').text(cupsForToppers);
  $('.largeBagsforToppers').text(largeBagsforToppers);
  //$('.smallBagsforToppers').text(smallBagsforToppers);
  $('.costforToppers').text(formatter.format(costforToppers * 1.2 / 2));
  
  
});


const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',

  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});